/**
 * Datasheet form (HubSpot) – get form data, send thank-you email after submit.
 * Patches hbspt.forms.create so we capture data and trigger email for the datasheet form.
 */
(function () {
  var DATASHEET_FORM_ID = '725a53ab-8f7e-4a29-bfad-d9a4205d4a07';
  var CONTACT_SALES_FORM_ID = '0fd74f38-5eac-4ed9-b81d-8a2c8ed752ce';
  var DATASHEET_EMAIL_API = 'https://shopify-customers-integration-app-kappa.vercel.app/api/datasheet-email';
  var lastSubmissionForEmail = null;

  function getValueFromSubmission(submissionValues, name) {
    if (!submissionValues || typeof submissionValues.length === 'undefined') return '';
    for (var i = 0; i < submissionValues.length; i++) {
      var f = submissionValues[i];
      if (f && f.name === name) return f.value != null ? String(f.value) : '';
    }
    return '';
  }

  window.getDatasheetFormData = function (submissionValues) {
    if (!submissionValues || typeof submissionValues.length === 'undefined') return null;
    return {
      firstName: getValueFromSubmission(submissionValues, 'firstname'),
      lastName: getValueFromSubmission(submissionValues, 'lastname'),
      email: getValueFromSubmission(submissionValues, 'email'),
      phone: getValueFromSubmission(submissionValues, 'phone'),
      company: getValueFromSubmission(submissionValues, 'company'),
      country: getValueFromSubmission(submissionValues, 'contact_testing'),
      datasheetName: getValueFromSubmission(submissionValues, 'datasheet_name')
    };
  };

  function sendThankYouEmail(payload) {
    if (!payload || !payload.email) return;
    var typeElement = document.querySelector('.popup_header_content');
    var typeValue = typeElement ? typeElement.innerText.trim() : '';
    fetch(DATASHEET_EMAIL_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: typeValue,   // <-- new field
        firstName: payload.firstName,
        lastName: payload.lastName,
        email: payload.email,
        phone:payload.phone,
        country: payload.country,
        tags: payload.datasheetName || '',
        note: 'Company: ' + (payload.company || '')
      })
    }).then(function (res) { return res.json(); }).catch(function () {});
  }

  function patchHubspotFormsCreate() {
   
    if (typeof window.hbspt === 'undefined' || !window.hbspt.forms || typeof window.hbspt.forms.create !== 'function') return;
    if (window.hbspt.forms.create._datasheetPatched) return;
    var originalCreate = window.hbspt.forms.create;
   
    window.hbspt.forms.create = function (options) {
      if (options && options.formId === DATASHEET_FORM_ID) {
        var existingBefore = options.onBeforeFormSubmit;
        var existingSubmitted = options.onFormSubmitted;
        options.onBeforeFormSubmit = function ($form, submissionValues) {
          if (existingBefore) try { existingBefore($form, submissionValues); } catch (e) {}
          lastSubmissionForEmail = window.getDatasheetFormData(submissionValues);
        };
        options.onFormSubmitted = function () {
          if (lastSubmissionForEmail) {
            sendThankYouEmail(lastSubmissionForEmail);
            lastSubmissionForEmail = null;
          }
          if (existingSubmitted) try { existingSubmitted(); } catch (e) {}
        };
      }




      return originalCreate.call(this, options);
    };
    window.hbspt.forms.create._datasheetPatched = true;
  }

  patchHubspotFormsCreate();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchHubspotFormsCreate);
  }
  setTimeout(patchHubspotFormsCreate, 500);
})();



//contact sales form
// contact sales form (updated)
(function () {

  function getValueFromSubmission(values, key) {
    if (!values) return '';

    // Handle BOTH formats (array OR object)
    if (Array.isArray(values)) {
      for (var i = 0; i < values.length; i++) {
        if (values[i].name === key) {
          return values[i].value || '';
        }
      }
      return '';
    }

    // object format
    return values[key] || '';
  }

  window.addEventListener("message", function (event) {

    if (!event.data || event.data.type !== 'hsFormCallback') return;

    // 🔒 Ensure only CONTACT SALES form
    if (event.data.id !== '0fd74f38-5eac-4ed9-b81d-8a2c8ed752ce') return;

    if (event.data.eventName === 'onFormSubmitted') {

      const submissionValues = event.data.data.submissionValues || {};

      // ✅ Map fields properly
      const payload = {
        type: 'sale_form',

        firstName: getValueFromSubmission(submissionValues, 'firstname'),
        lastName: getValueFromSubmission(submissionValues, 'lastname'),
        email: getValueFromSubmission(submissionValues, 'email'),
        phone: getValueFromSubmission(submissionValues, 'phone'),
        company: getValueFromSubmission(submissionValues, 'company'),
        country: getValueFromSubmission(submissionValues, 'contact_testing'),
        message: getValueFromSubmission(submissionValues, 'message'),

        pageUrl: window.location.href,
        submittedAt: new Date().toISOString()
      };

      console.log("Payload:", payload);

      // ✅ Prevent duplicate firing
      if (window.__contactSalesSubmitted) return;
      window.__contactSalesSubmitted = true;

      fetch('https://shopify-customers-integration-app-kappa.vercel.app/api/datasheet-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(res => res.json())
      .then(data => {
        //console.log("✅ Sent to server:", data);
      })
      .catch(err => {
        //console.error("❌ API error:", err);
      });

    }

  });

})();